const shippingTypeEnum = Object.freeze({
    GLOBAL: 0,
    FREE: 5,
    FLAT_RATE: 10
});
export default shippingTypeEnum;
